module.exports = __webpack_public_path__ + "img/spezialisierungen_1920.43c4c25d.png";